import styled from 'styled-components';


/*
========================================
PÁGINA
========================================
*/

export const PaginaInvitacion =
    styled.div`

    width:
        100%;

    min-height:
        100vh;

    box-sizing:
        border-box;

    padding:
        2.5rem
        1rem
        4rem
        1rem;

    background-color:
        #F7FAFA;
`;


/*
========================================
CONTENEDOR
========================================
*/

export const ContenedorInvitacion =
    styled.div`

    width:
        min(
            100%,
            900px
        );

    margin:
        0 auto;
`;


/*
========================================
ENCABEZADO
========================================
*/

export const EncabezadoInvitacion =
    styled.div`

    margin-bottom:
        1.5rem;

    text-align:
        center;
`;


export const MarcaInvitacion =
    styled.div`

    margin-bottom:
        0.4rem;

    font-size:
        0.78rem;

    font-weight:
        800;

    letter-spacing:
        0.08em;

    color:
        #655EE8;
`;


export const TituloInvitacion =
    styled.h1`

    margin:
        0;

    font-size:
        1.5rem;

    font-weight:
        800;

    color:
        #23AAAF;
`;


export const SubtituloInvitacion =
    styled.p`

    max-width:
        650px;

    margin:
        0.7rem
        auto
        0
        auto;

    font-size:
        0.86rem;

    line-height:
        1.55;

    color:
        #646464;
`;


/*
========================================
TARJETA
========================================
*/

export const TarjetaInvitacion =
    styled.div`

    width:
        100%;

    box-sizing:
        border-box;

    padding:
        2rem
        2.2rem;

    border:
        1.5px solid
        #69BEB8;

    border-radius:
        22px;

    background-color:
        #FFFFFF;

    box-shadow:
        0
        8px
        30px
        rgba(
            0,
            0,
            0,
            0.06
        );


    @media (max-width: 650px) {

        padding:
            1.4rem
            1rem;
    }
`;


/*
========================================
SECCIÓN
========================================
*/

export const SeccionInvitacion =
    styled.section`

    width:
        100%;
`;


export const TituloSeccionInvitacion =
    styled.h2`

    margin:
        0
        0
        0.35rem
        0;

    font-size:
        1rem;

    font-weight:
        800;

    color:
        #23AAAF;
`;


export const TextoSeccionInvitacion =
    styled.p`

    margin:
        0
        0
        1rem
        0;

    font-size:
        0.78rem;

    line-height:
        1.5;

    color:
        #646464;
`;


export const SeparadorInvitacion =
    styled.div`

    width:
        100%;

    height:
        1px;

    margin:
        1.7rem
        0;

    background-color:
        #D9D9D9;
`;


/*
========================================
GRID
========================================
*/

export const GridInvitacion =
    styled.div`

    display:
        grid;

    grid-template-columns:
        repeat(
            2,
            minmax(
                0,
                1fr
            )
        );

    gap:
        1rem
        1.3rem;


    @media (max-width: 650px) {

        grid-template-columns:
            1fr;
    }
`;


/*
========================================
CAMPO
========================================
*/

export const CampoInvitacion =
    styled.label`

    display:
        flex;

    flex-direction:
        column;

    gap:
        0.35rem;

    min-width:
        0;

    box-sizing:
        border-box;


    &[data-completo="true"] {

        grid-column:
            1 / -1;
    }
`;


export const LabelInvitacion =
    styled.span`

    font-size:
        0.78rem;

    font-weight:
        700;

    color:
        #2B2B2B;


    strong {

        color:
            #655EE8;
    }
`;


/*
========================================
INPUT
========================================
*/

export const InputInvitacion =
    styled.input`

    width:
        100%;

    min-width:
        0;

    height:
        40px;

    box-sizing:
        border-box;

    padding:
        0
        0.75rem;

    border:
        1px solid
        ${
            props =>
                props.$error
                    ?
                    '#E7973C'
                    :
                    '#B8DEDC'
        };

    border-radius:
        8px;

    outline:
        none;

    background-color:
        ${
            props =>
                props.$error
                    ?
                    '#FFF4E8'
                    :
                    '#F3FAFA'
        };

    font-family:
        inherit;

    font-size:
        0.84rem;

    color:
        #2B2B2B;

    transition:
        border-color 0.15s ease,
        background-color 0.15s ease,
        box-shadow 0.15s ease;


    &:focus {

        border-color:
            #23AAAF;

        background-color:
            #FFFFFF;

        box-shadow:
            0
            0
            0
            2px
            rgba(
                35,
                170,
                175,
                0.12
            );
    }


    &:disabled {

        background-color:
            #F4F4F2;

        color:
            #777777;

        cursor:
            not-allowed;
    }
`;


/*
========================================
ERROR CAMPO
========================================
*/

export const ErrorCampoInvitacion =
    styled.span`

    font-size:
        0.7rem;

    font-weight:
        700;

    color:
        #C96F1B;
`;


/*
========================================
EMAIL PACIENTE
========================================
*/

export const EmailPacienteInvitacion =
    styled.div`

    box-sizing:
        border-box;

    margin-bottom:
        1rem;

    padding:
        0.8rem
        1rem;

    border:
        1px solid
        #D7D4F4;

    border-radius:
        10px;

    background-color:
        #F7F6FE;

    font-size:
        0.8rem;

    color:
        #514BBE;


    strong {

        font-weight:
            800;
    }
`;


/*
========================================
PASSWORD
========================================
*/

export const ContenedorPassword =
    styled.div`

    position:
        relative;
`;


export const BotonMostrarPassword =
    styled.button`

    position:
        absolute;

    top:
        50%;

    right:
        0.6rem;

    transform:
        translateY(-50%);

    border:
        none;

    background:
        transparent;

    color:
        #655EE8;

    font-family:
        inherit;

    font-size:
        0.72rem;

    font-weight:
        800;

    cursor:
        pointer;
`;


export const AyudaPassword =
    styled.div`

    box-sizing:
        border-box;

    margin-top:
        0.8rem;

    padding:
        0.8rem
        1rem;

    border-left:
        4px solid
        #655EE8;

    border-radius:
        8px;

    background-color:
        #F7F6FE;

    font-size:
        0.74rem;

    line-height:
        1.55;

    color:
        #514BBE;
`;


/*
========================================
TUTOR YA EXISTENTE
========================================
*/

export const AvisoTutorExistente =
    styled.div`

    grid-column:
        1 / -1;

    box-sizing:
        border-box;

    padding:
        0.75rem
        0.9rem;

    border:
        1px solid
        #D7D4F4;

    border-radius:
        9px;

    background-color:
        #F7F6FE;

    font-size:
        0.75rem;

    line-height:
        1.45;

    color:
        #514BBE;
`;


/*
========================================
AVISO GENERAL
========================================
*/

export const AvisoInvitacion =
    styled.div`

    box-sizing:
        border-box;

    margin-bottom:
        1.2rem;

    padding:
        0.85rem
        1rem;

    border:
        1.5px solid
        #E7973C;

    border-radius:
        10px;

    background-color:
        #FFF4E8;

    font-size:
        0.78rem;

    font-weight:
        700;

    line-height:
        1.5;

    color:
        #C96F1B;
`;


/*
========================================
ACCIONES
========================================
*/

export const AccionesInvitacion =
    styled.div`

    display:
        flex;

    align-items:
        center;

    justify-content:
        flex-end;

    margin-top:
        1.8rem;
`;


export const BotonCrearPaciente =
    styled.button`

    min-height:
        42px;

    box-sizing:
        border-box;

    padding:
        0.65rem
        1.4rem;

    border:
        none;

    border-radius:
        9px;

    background-color:
        #FC8906;

    color:
        #FFFFFF;

    font-family:
        inherit;

    font-size:
        0.82rem;

    font-weight:
        800;

    cursor:
        pointer;


    &:hover:not(:disabled) {

        opacity:
            0.9;
    }


    &:disabled {

        background-color:
            #D8D8D4;

        color:
            #777777;

        cursor:
            not-allowed;
    }
`;


/*
========================================
ESTADO CARGA
========================================
*/

export const EstadoInvitacion =
    styled.div`

    box-sizing:
        border-box;

    padding:
        2rem;

    border:
        1.5px solid
        #69BEB8;

    border-radius:
        20px;

    background-color:
        #FFFFFF;

    text-align:
        center;

    font-size:
        0.86rem;

    line-height:
        1.5;

    color:
        #646464;
`;